import Vue from "vue";
import Vuex, { createLogger, Store, StoreOptions } from "vuex";
import { RootState } from "@/store/type";
import { category } from "@/store/category";
import { customer } from "@/store/customer";
import { ui } from "@/store/ui";
import SessionService from "@/services/SessionService";
import Api from "@/api/Api";

Vue.use(Vuex);

const stateHydrationPlugin = (store: Store<RootState>) => {
  const savedCustomer = SessionService.getCustomer();

  if (savedCustomer) {
    store.dispatch('setCustomer', savedCustomer).catch(e => {
      console.error(e);
      SessionService.saveCustomer(null);
    });
  } else {
    Api.account.getCustomer().then();
  }
};

const debug = process.env.NODE_ENV !== "production";

const plugins = debug ? [createLogger<RootState>()] : [];
plugins.push(stateHydrationPlugin);

const store: StoreOptions<RootState> = {
  modules: {
    category,
    customer,
    ui
  },
  strict: debug,
  devtools: debug,
  plugins
};

export default new Vuex.Store<RootState>(store);